import React, { useMemo, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Section, Wrapper, SectionHead } from "../SectionHead";
import {
  FeaturedLabel,
  FeaturedGrid,
  FilterRow,
  FilterButton,
  FilterPill,
  CardGrid,
} from "./ProjectsStyle";
import ProjectCard from "../Cards/ProjectCards";
import { fadeUp, viewportOnce } from "../../utils/motion";
import { projects } from "../../data/constants";

const FILTERS = [
  { id: "all", label: "All" },
  { id: "web app", label: "Web Apps" },
  { id: "android app", label: "Android Apps" },
  { id: "AI & Others", label: "AI & Others" },
];

const Projects = ({ openModal, setOpenModal }) => {
  const [toggle, setToggle] = useState("all");

  const featured = useMemo(() => projects.filter((p) => p.featured), []);
  const visible = useMemo(() => {
    if (toggle === "all") return projects.filter((p) => !p.featured);
    return projects.filter((p) => p.category === toggle);
  }, [toggle]);

  return (
    <Section id="projects" style={{ scrollMarginTop: 96 }}>
      <Wrapper>
        <SectionHead
          eyebrow="Selected Work"
          title="A few things I've built and shipped."
          subtitle="Some are platforms running in production today, others are client work or personal builds across web, mobile, and machine learning."
        />

        {toggle === "all" && featured.length > 0 && (
          <>
            <FeaturedLabel>Featured</FeaturedLabel>
            <FeaturedGrid>
              {featured.map((project, i) => (
                <motion.div
                  key={project.id}
                  variants={fadeUp}
                  initial="hidden"
                  whileInView="visible"
                  viewport={viewportOnce}
                  custom={i}
                >
                  <ProjectCard project={project} setOpenModal={setOpenModal} featured />
                </motion.div>
              ))}
            </FeaturedGrid>
          </>
        )}

        <FilterRow>
          {FILTERS.map((f) => (
            <FilterButton key={f.id} $active={toggle === f.id} onClick={() => setToggle(f.id)}>
              {toggle === f.id && (
                <FilterPill layoutId="filter-pill" transition={{ type: "spring", stiffness: 380, damping: 32 }} />
              )}
              <span style={{ position: "relative", zIndex: 1 }}>{f.label}</span>
            </FilterButton>
          ))}
        </FilterRow>

        <CardGrid>
          <AnimatePresence mode="popLayout">
            {visible.map((project, i) => (
              <motion.div
                key={project.id}
                layout
                variants={fadeUp}
                initial="hidden"
                animate="visible"
                exit={{ opacity: 0, scale: 0.95 }}
                viewport={viewportOnce}
                custom={i % 6}
              >
                <ProjectCard project={project} setOpenModal={setOpenModal} />
              </motion.div>
            ))}
          </AnimatePresence>
        </CardGrid>
      </Wrapper>
    </Section>
  );
};

export default Projects;
